import { render, staticRenderFns } from "./TrueWindGauge.vue?vue&type=template&id=bb396b04&scoped=true&"
import script from "./TrueWindGauge.vue?vue&type=script&lang=js&"
export * from "./TrueWindGauge.vue?vue&type=script&lang=js&"
import style0 from "./TrueWindGauge.vue?vue&type=style&index=0&id=bb396b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb396b04",
  null
  
)

export default component.exports